(() => {
  'use strict';
  const initialize = root => {
  if (!root || root.dataset.compareReady) return;
  const limit = 3, selected = new Map(), facts = new Map();
  const tray = root.querySelector('[data-compare-tray]');
  const dialog = root.querySelector('[data-compare-dialog]');
  const status = root.querySelector('[data-compare-status]');
  const openButton = root.querySelector('[data-compare-open]');
  const closeButton = root.querySelector('[data-compare-close]');
  const content = root.querySelector('[data-compare-content]');
  if(!tray||!dialog||!status||!openButton||!closeButton||!content||!root.querySelector('[data-compare-count]')||!root.querySelector('[data-compare-selected]'))return;
  root.dataset.compareReady = 'true';
  let opener, renderVersion=0;
  const clean = value => typeof value==='string'?value.replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 240):'';
  const locale = location.pathname.match(/^\/([a-z]{2,3}(?:-[a-z0-9]{2,8})*)(?:\/|$)/)?.[1] || '';
  const schema = 'kalia.shade-comparison.v1', storageKey = `kalia.compare.shades.v1:${locale || 'default'}`, ttl = 24 * 60 * 60 * 1000;
  const plain = value => value !== null && typeof value === 'object' && !Array.isArray(value) && Object.getPrototypeOf(value) === Object.prototype;
  const exactKeys = (value, keys) => plain(value) && Object.keys(value).length === keys.length && keys.every(key => Object.prototype.hasOwnProperty.call(value,key));
  const text = (value, maximum, required = true) => typeof value === 'string' && value.length <= maximum && (!required || value.trim().length > 0) && !/[\u0000-\u001f\u007f]/.test(value);
  const unique = values => [...new Set(values.map(clean).filter(Boolean))];
  const node = (tag, value, className) => {
    const el = document.createElement(tag);
    if (value !== undefined) el.textContent = value;
    if (className) el.className = className;
    return el;
  };
  const productURL = value => {
    try {
      if (!text(value,500)) return null;
      const u = new URL(value, location.href);
      const parts = u.pathname.match(/^(?:\/([a-z]{2,3}(?:-[a-z0-9]{2,8})*))?\/products\/([a-z0-9]+(?:-[a-z0-9]+)*)$/);
      return u.origin === location.origin && !u.username && !u.password && parts && (parts[1] || '') === locale && !u.search && !u.hash ? u.pathname : null;
    } catch (_) { return null; }
  };
  const configURL = value => {
    try {
      if (!text(value,1400)) return null;
      const u = new URL(value, location.href);
      const versions = [...u.searchParams];
      return u.origin === location.origin && !u.username && !u.password && !u.hash && /^\/(?:cdn\/shop\/t\/[1-9]\d*\/)?assets\/kalia-config-[a-z0-9-]+\.json$/.test(u.pathname) && (versions.length === 0 || versions.length === 1 && versions[0][0] === 'v' && /^\d{1,40}$/.test(versions[0][1])) ? u.href : null;
    } catch (_) { return null; }
  };
  const identity = data => {
    if (!data || !text(data.handle,150) || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(data.handle) || !text(data.title,240) || !text(data.type,240,false)) return null;
    const url = productURL(data.url), config = configURL(data.config);
    if (!url || !config || url.split('/').pop() !== data.handle) return null;
    // The native handle and exact configuration asset are the identities supplied by Liquid.
    // Neither a numeric product ID nor a supplier ID is invented from display text.
    return {handle:data.handle,title:data.title,type:data.type,url,config};
  };
  const forget = () => { try { sessionStorage.removeItem(storageKey); } catch (_) {} };
  const remember = () => {
    if (!selected.size) { forget(); return; }
    try {
      const items = [...selected.values()].map(identity);
      if (items.some(item => !item)) return;
      // Prices are deliberately excluded: another page cannot prove a stored price is current.
      sessionStorage.setItem(storageKey,JSON.stringify({schema,origin:location.origin,locale,updatedAt:Date.now(),items}));
    } catch (_) { /* Comparison remains usable when session storage is unavailable. */ }
  };
  const restore = () => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) return;
      if (raw.length > 8000) { forget(); return; }
      const saved = JSON.parse(raw), now = Date.now();
      if (!exactKeys(saved,['schema','origin','locale','updatedAt','items']) || saved.schema !== schema || saved.origin !== location.origin || saved.locale !== locale || !Number.isSafeInteger(saved.updatedAt) || saved.updatedAt > now || now - saved.updatedAt >= ttl || !Array.isArray(saved.items) || saved.items.length < 1 || saved.items.length > limit) { forget(); return; }
      const items = saved.items.map(item => exactKeys(item,['handle','title','type','url','config']) ? identity(item) : null);
      if (items.some(item => !item) || new Set(items.map(item => item.handle)).size !== items.length) { forget(); return; }
      items.forEach(item => selected.set(item.handle,item));
    } catch (_) { /* Malformed or inaccessible storage never prevents a fresh comparison. */ }
  };
  const getCard = button => {
    const card = button.closest('.kalia-product-card');
    let data;
    try { data = JSON.parse(button.getAttribute('data-compare-product') || 'null'); } catch (_) { return null; }
    if(!data||typeof data!=='object'||Array.isArray(data))return null;
    const item = identity({...data,title:clean(data.title),type:clean(data.type)});
    if (!item || !card) return null;
    return {...item,
      price: clean(card.querySelector('.kalia-product-card-price')?.textContent?.replace(/\s+/g, ' ').trim())};
  };
  const describe = data => {
    if(data?.studio?.pricingVerified!==true||!Array.isArray(data.studio.enabledFieldIds)||!Array.isArray(data.fields)||!Array.isArray(data.skus))throw new Error('Configuration unavailable');
    const enabled = new Set(data.studio.enabledFieldIds);
    const fields = data.fields.filter(f => f && enabled.has(f.id));
    const options = title => unique(fields.filter(f => title.test(clean(f.title).trim())).flatMap(f => {
      const disabled = new Set(Array.isArray(data.studio.disabledOptionIdsByField?.[f.id]) ? data.studio.disabledOptionIdsByField[f.id] : []);
      return Array.isArray(f.options) ? f.options.filter(o => o && !disabled.has(o.id) && Number.isInteger(o.feeCents) && o.feeCents >= 0).map(o => o.label) : [];
    }));
    const styles = unique(data.skus.map(s => s?.options?.Style));
    const linings = options(/^Lining(?: Type)?$/i);
    const lightChoices = unique([...styles, ...linings]);
    const solar = /\bsolar\b/i.test(clean(data.title));
    const variablePrivacy = lightChoices.some(value => /light[ -]?filtering|sheer|unlined|no lining|no need/i.test(value));
    const blackout = lightChoices.some(value => /blackout/i.test(value));
    const privacy = solar ? 'Solar fabric is not a nighttime privacy layer.'
      : variablePrivacy ? 'Privacy varies by fabric. Check with indoor lights on.'
      : blackout ? 'Blackout option listed; confirm opacity and edge coverage.'
      : 'Confirm privacy for your fabric with indoor lights on.';
    const mounts = options(/^(?:Mount Type|Inside & Outside)$/i);
    const controls = options(/^(?:Control Type|Lift Style)$/i).map(v => v.replace(/Continous/gi, 'Continuous'));
    const fixed=data.studio.fixedProperties||{};
    if(!mounts.length&&clean(fixed.Mount))mounts.push(clean(fixed.Mount));
    if(!controls.length&&clean(fixed.Operation))controls.push(clean(fixed.Operation));
    return {light: lightChoices.length ? `${styles.length ? styles.join(' · ') : ''}${styles.length && linings.length ? '. ' : ''}${linings.length ? `Lining: ${linings.join(' · ')}` : ''}` : solar ? 'Solar fabric. Check openness and light transmission.' : 'Check the selected fabric on the product page.', privacy,
      mount: mounts.length ? mounts.join(' · ') : 'Confirm on product page',
      control: controls.length ? controls.join(' · ') : 'See motor and control choices on product page'};
  };
  const load = async item => {
    if (facts.has(item.config)) return facts.get(item.config);
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);
    const pending = Promise.resolve().then(()=>fetch(item.config, {credentials: 'same-origin',headers:{Accept:'application/json'},signal:controller.signal})).then(r => {
      if (!r.ok) throw new Error('Configuration unavailable');
      return r.json();
    }).then(describe).catch(() => { facts.delete(item.config);return {light: 'Check product details', privacy: 'Confirm the selected fabric on the product page', mount: 'Check product details', control: 'Check product details'}; }).finally(()=>clearTimeout(timer));
    facts.set(item.config, pending);
    return pending;
  };
  const sync = () => {
    const current = new Map(Array.from(root.querySelectorAll('[data-compare-toggle]')).map(getCard).filter(Boolean).map(item => [item.handle,item]));
    // Current native card metadata wins over session data, including a newer asset URL/title.
    selected.forEach((item,handle) => { selected.set(handle,current.get(handle) || {...item,price:''}); });
    tray.hidden = selected.size === 0;
    root.querySelector('[data-compare-count]').textContent = `${selected.size} / ${limit} selected`;
    const labels = root.querySelector('[data-compare-selected]');
    labels.replaceChildren();
    for (const item of selected.values()) {
      const button = node('button', `${item.title} ×`);
      button.type = 'button';
      button.setAttribute('aria-label', `Remove ${item.title} from comparison`);
      button.addEventListener('click', () => {
        const index = [...selected.keys()].indexOf(item.handle);
        selected.delete(item.handle); sync(); remember(); status.textContent=`${item.title} removed from comparison.`;
        const cardButton = Array.from(root.querySelectorAll('[data-compare-toggle]')).find(toggle=>getCard(toggle)?.handle===item.handle);
        const remaining = Array.from(labels.querySelectorAll('button'));
        const fallback = remaining[Math.min(index,remaining.length-1)] || Array.from(root.querySelectorAll('[data-compare-toggle]')).find(toggle=>!toggle.hidden);
        (cardButton || fallback)?.focus();
      });
      labels.append(button);
    }
    openButton.disabled = selected.size < 2;
    root.querySelectorAll('[data-compare-toggle]').forEach(button => {
      const card = getCard(button); if (!card) {button.hidden=true;return;}
      button.hidden=false;button.setAttribute('aria-label',`Compare ${card.title}`);
      const active = selected.has(card.handle);
      button.setAttribute('aria-pressed', String(active));
      button.textContent = active ? 'Added to compare ✓' : 'Compare +';
    });
  };
  const close = () => { ++renderVersion; if (dialog.open) dialog.close(); if(opener?.isConnected)opener.focus(); };
  const render = async () => {
    const version=++renderVersion;
    const items = [...selected.values()].map(item=>({...item,price:''}));
    // Read current visible card prices; comparison never reprices products or configures a cart.
    items.forEach(item=>{
      const current=Array.from(root.querySelectorAll('[data-compare-toggle]')).map(getCard).find(card=>card?.handle===item.handle);
      if(current)item.price=current.price;
    });
    content.textContent = 'Loading product choices…';
    content.setAttribute('aria-busy','true');
    const values = await Promise.all(items.map(load));
    if (!dialog.open||version!==renderVersion||!root.isConnected) return;
    const table = node('table');
    table.append(node('caption', 'Model choices. Combinations depend on fabric, size and controls.'));
    const thead = node('thead'), tr = node('tr');
    const corner = node('th', 'Compare'); corner.scope = 'col'; tr.append(corner);
    items.forEach(item => { const th = node('th'); th.scope = 'col'; const link = node('a', item.title); link.href = item.url; th.append(link); tr.append(th); });
    thead.append(tr); table.append(thead);
    const body = node('tbody');
    for (const [title, key] of [['Style', 'type'], ['Starting price', 'price'], ['Light choices', 'light'], ['Privacy after dark', 'privacy'], ['Mount options', 'mount'], ['Control options', 'control']]) {
      const row = node('tr'), heading = node('th', title); heading.scope = 'row'; row.append(heading);
      items.forEach((item, i) => {
        const cell = node('td');
        if (key === 'price' && !item.price) { const link = node('a','See current price'); link.href = item.url; cell.append(link); }
        else cell.textContent = key in item ? item[key] || 'See product details' : values[i][key];
        row.append(cell);
      });
      body.append(row);
    }
    const row = node('tr'); const th = node('th', 'Next step'); th.scope = 'row'; row.append(th);
    items.forEach(item => { const cell = node('td'), link = node('a', 'Customize this shade →'); link.href = item.url; cell.append(link); row.append(cell); });
    body.append(row); table.append(body); content.replaceChildren(table);content.setAttribute('aria-busy','false');
  };
  root.addEventListener('click',event=>{
      const button=event.target.closest?.('[data-compare-toggle]');if(!button||!root.contains(button))return;
      const card=getCard(button);if(!card)return;
      if (selected.has(card.handle)) selected.delete(card.handle);
      else if (selected.size < limit) selected.set(card.handle, card);
      else { status.textContent = 'Compare up to 3 shades. Remove one to add another.'; return; }
      status.textContent = `${selected.size} shade${selected.size === 1 ? '' : 's'} selected. Choose 2 or 3 to compare.`;
      sync();remember();
  });
  openButton.addEventListener('click', event => {
    if (selected.size < 2) return;
    opener = event.currentTarget;
    if (typeof dialog.showModal !== 'function') { status.textContent = 'Open each product to compare its options.'; return; }
    if(dialog.open)return;
    dialog.showModal();closeButton.focus();render();
  });
  closeButton.addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault();close(); });
  dialog.addEventListener('close',()=>{if(!dialog.open){++renderVersion;if(opener?.isConnected)opener.focus();}});
  const grid=root.querySelector('.kalia-catalog-grid');
  if(grid&&typeof MutationObserver==='function'){
    const observer=new MutationObserver(records=>{if(records.some(record=>Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node=>node.nodeType===1&&(node.matches?.('.kalia-product-card, [data-compare-toggle]')||node.querySelector?.('[data-compare-toggle]')))))sync();});observer.observe(grid,{childList:true,subtree:true});
    const unload=event=>{if(event.target.contains(root)){observer.disconnect();++renderVersion;document.removeEventListener('shopify:section:unload',unload);}};
    document.addEventListener('shopify:section:unload',unload);
  }
  restore();sync();
  if(selected.size)status.textContent=`${selected.size} saved shade${selected.size===1?'':'s'} ready to compare. Current prices are shown on each product page.`;
  };
  document.querySelectorAll('[data-kalia-compare]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-kalia-compare]').forEach(initialize));
})();
